import { TFunction } from 'i18next';

// Entity-dependent copy for the AI assistant. The assistant currently serves
// documentation only, but other entities (pages) will reuse the same modal —
// add a texts factory per entity and pass it from the calling page.
export type AiAssistantTexts = {
  modalTitle: string;
  emptyTitle: string;
  emptySubtitle: string;
  inputPlaceholder: string;
  suggestions: string[];
};

export function getDocumentAiAssistantTexts(
  t: TFunction<'translation', undefined>,
): AiAssistantTexts {
  return {
    modalTitle: t('ai-assistant-modal-title'),
    emptyTitle: t('ai-empty-title'),
    emptySubtitle: t('ai-empty-subtitle'),
    inputPlaceholder: t('ai-input-placeholder'),
    suggestions: [
      t('ai-suggestion-1'),
      t('ai-suggestion-2'),
      t('ai-suggestion-3'),
    ],
  };
}
